export default {
    namespaced: true,
    state: {
      setMargin: {
        show: false,
        type: "",
        id: null,
      },
    },
    getters: {
      getShow: (state) => state.setMargin.show,
    },
    mutations: {
      TOGGLE_SET_MARGIN_LIST(state, obj) {
        if (obj.show) {
          (state.setMargin.type = obj.type ? obj.type : ""),
            (state.setMargin.id = obj.id ? obj.id : null);
        }
        state.setMargin.show = obj.show;
      },
    },
    actions: {
      toggleSetMargin({ commit }, obj) {
        commit("TOGGLE_SET_MARGIN_LIST", obj);
      },
    },
  };
  